import styled from "@emotion/styled"

const ArticleRelatedArticleInfoAuthor = styled.div`
  display: flex;
  align-items: flex-start;

  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
    gap: 7px;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
`

export default ArticleRelatedArticleInfoAuthor